import { Button, Grid, Paper, Tooltip } from "@material-ui/core";
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import EmptyPlaceholder from 'components/EmptyPlaceholder/EmptyPlaceholder';
import LoadingSpinner from "components/LoadingSpinner";
import { formTypeLabels } from "features/Forms/formBuilder/formBuilderConsts";
import { IconArrowRightCircle, IconCalendarCircle, IconDownload, IconEdit, IconWarning } from "icons";
import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from 'react-router-dom';
import FormatService from "services/formatService";
import FormFailure from "../../Forms/FormOutput/FormFailure";
import { useGetCustomFormResponseQuery } from "../VehicleCustomForm/CustomFormResponseSlice";
import CustomFormProgressBar from "./CustomFormProgressBar";
import { customFormResponseStatus, customFormResponseStatusList } from "./CustomFormResponseEnum";
import { VehicleCustomForm } from './VehicleCustomForm';
import { customFormStyle } from "./style";
import { CustomFormSyncProgress } from "./syncProgress/CustomFormSyncProgress";

export const VehicleCustomFormList = ({ vehicle, formType, formLabel }) => {
    var classes = customFormStyle();
    const history = useHistory();
    let { tab, responseId } = useParams();
    const parsedResponseId = Number(responseId);
    const [selectedResponseId, setSelectedResponseId] = useState(
        parsedResponseId > 0 ? parsedResponseId : null
    );
    const [mode, setMode] = useState(null);
    const [showFailuresOnly, setShowFailuresOnly] = useState(false);

    let { data: customFormResponses, error: formError, isLoading: isLoadingForms } = useGetCustomFormResponseQuery({
        vehicleId: vehicle?.id,
        formType: formType,
        workOrderId: 0,
        includeImages: true,
        activityItemId: 0
    });
    customFormResponses = customFormResponses || [];

    useEffect(() => {
        setMode(null);
        setSelectedResponseId(null);
    }, [formType]);

    useEffect(() => {
        setSelectedResponseId(parsedResponseId > 0 ? parsedResponseId : null);
    }, [parsedResponseId]);

    const henadleClick = (id, mode) => {
        setMode(mode);
        setSelectedResponseId(id);
        setShowFailuresOnly(false);
        history.push(`${window.location.pathname}/${id}`);
    }

    const goBack = () => {
        setMode(null);
        setSelectedResponseId(null);
        history.push(`/assets/detail/${vehicle?.id}/${tab}`);
    }

    const onClickFailure = (id) => {
        henadleClick(id, 'edit');
        setShowFailuresOnly(true);
    }

    return (
        <>
            {selectedResponseId > 0 && <Button variant="outlined" className={classes.backButton} startIcon={<ArrowBackIosRoundedIcon />} onClick={goBack}>Go Back</Button>}
            <Paper className={isLoadingForms ? classes.loadingCard : classes.card}>
                <Grid container spacing={2}>
                    <LoadingSpinner loading={isLoadingForms} />
                    {selectedResponseId == null && customFormResponses?.length > 0 &&
                        customFormResponses?.map((customFormResponse, index) => (
                            <Grid item xs={12} className={classes.itemContainer} key={index}>
                                <Grid item xs={12} className={classes.itemWrapper}>
                                    <div className={classes.buttonsWrapper}>
                                        <CustomFormSyncProgress customFormResponse={customFormResponse} vehicleId={customFormResponse?.vehicleId} />
                                        <IconArrowRightCircle />
                                        <h2 className={classes.title}>{formLabel ?? formTypeLabels[formType]}</h2>
                                        <IconCalendarCircle />
                                        <h2 className={classes.title}>{FormatService.formatDateNoConversion(customFormResponse?.answers?.[0]?.createdDate)}</h2>
                                        {customFormResponse?.status === customFormResponseStatus.IN_PROGRESS &&
                                            <Tooltip placement="top" title={customFormResponseStatusList?.find(s => s.id == customFormResponseStatus.IN_PROGRESS)?.name || "Not Completed"}>
                                                <div className={classes.inProgressWarning}><IconWarning size={20} /></div>
                                            </Tooltip>}
                                    </div>
                                    <div className={classes.buttonsWrapper} style={{ gap: "0.5rem" }}>
                                        <Authorize profile={permissionProfiles.FORMS.EDIT_FORM_RESPONSE}>
                                            <FormFailure customFormResponse={customFormResponse} onClickFailure={() => onClickFailure(customFormResponse?.id)} />
                                        </Authorize>
                                        <Button variant="outlined" startIcon={<IconDownload />} onClick={() => henadleClick(customFormResponse?.id, 'download')}                                >
                                            View & Download Report
                                        </Button>
                                        <Authorize profile={permissionProfiles.FORMS.EDIT_FORM_RESPONSE}>
                                            <Button variant="outlined" startIcon={<IconEdit />} onClick={() => henadleClick(customFormResponse?.id, 'edit')}                                >
                                                Edit
                                            </Button>
                                        </Authorize>
                                    </div>
                                </Grid>
                                <CustomFormProgressBar
                                    key={index}
                                    formResponse={customFormResponse}
                                />
                            </Grid>

                        ))
                    }
                    {selectedResponseId == null && customFormResponses?.length == 0 && !isLoadingForms && <EmptyPlaceholder />}
                    {selectedResponseId != null &&
                        <Grid item xs={12}>
                            <VehicleCustomForm
                                key={`${formType}-${selectedResponseId}`}
                                vehicle={vehicle}
                                formType={formType}
                                formLabel={formLabel}
                                customFormResponse={customFormResponses?.find(res => res.id == selectedResponseId)}
                                mode={mode}
                                isLoadingForm={isLoadingForms}
                                showFailuresOnly={showFailuresOnly}
                                setShowFailuresOnly={setShowFailuresOnly}
                            />
                        </Grid>
                    }
                </Grid>
            </Paper >
        </>
    )
}